export function TrashIcon() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="#FA485D"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 7v3M7 7v3"
        ></path>
        <path
          fill="#FA485D"
          d="M5 5v-.5a.5.5 0 00-.5.5H5zm6 0h.5a.5.5 0 00-.5-.5V5zm-6 .5h6v-1H5v1zm5.5-.5v6.533h1V5h-1zm0 6.5h-5v1h5v-1zm-5 .033V5h-1v6.533h1zm0-.033c-.011 0-.014-.004-.012-.002l.007.01a.061.061 0 01.005.025h-1c0 .566.48.967 1 .967v-1zm5 .033c0-.008.002-.017.005-.024a.034.034 0 01.007-.011c.002-.002 0 .002-.012.002v1c.52 0 1-.4 1-.967h-1z"
        ></path>
        <path
          stroke="#FA485D"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4 5h8"
        ></path>
        <path
          fill="#FA485D"
          d="M10 5v.5a.5.5 0 00.5-.5H10zM6 5h-.5a.5.5 0 00.5.5V5zm.5-1.5h3v-1h-3v1zm3 .167V5h1V3.667h-1zm.5.833H6v1h4v-1zM6.5 5V3.667h-1V5h1zm3-1.5c-.055 0-.066-.03-.046-.005.02.026.046.085.046.172h1c0-.282-.085-.557-.246-.772A.945.945 0 009.5 2.5v1zm-3-1c-.33 0-.592.18-.754.395-.161.215-.246.49-.246.772h1c0-.087.027-.146.046-.172.02-.026.009.005-.046.005v-1z"
        ></path>
      </svg>
    );
  }
  